<template>
<div
  class="modal-container"
  v-if="isDesktop"
  data-testid="modal-filter"
>
  <ul class="location-results--search">
    <template v-if="filteredLocations.length">
      <li v-for="loc in filteredLocations" :key="loc.code" >
        <button
          class="btn filtered-location-name"
          @click="handleClick(loc)"
          :aria-label="loc.name"
        >
          <span class="highlighted-text">{{ loc.name.slice(0, location.length) }}</span>
          <span>{{ loc.name.slice(location.length) }}</span>
        </button>
      </li>
    </template>

    <template v-else>
      <li class="no-results-msg">
        <span data-testid="no-results">{{ translate('offDealsNoMatchingResults') }}</span>
      </li>
    </template>
  </ul>
</div>
<div
  v-else-if="isMobile"
  class="modal-container-mobile"
  id="offers-location-modal"
  data-testid="modal-filter-mobile"
>
  <div class="location--header">
    <h2>{{translate('offLocation')}}</h2>
    <button
      class="btn"
      aria-label="Close"
      @click="emitToggle(false)"
      data-testid="close-modal-button"
    >
      <i class="icon-cross sm" />
    </button>
  </div>
  <div class="location--body">
    <div class="filter-input">
      <input
        data-testid="mobile-filter-input"
        type="text" v-model="inputLocation"
        :placeholder="translate('offLocation')"
      >
    </div>
    <ul class="location-results--search mobile-list" v-if="inputLocation.length > 0">
      <template v-if="filteredLocations.length">
        <li v-for="loc in filteredLocations" :key="loc.code">
          <button
            class="btn filtered-location-name"
            :aria-label="loc.name"
            @click="handleClick(loc)"
          >
            <span class="highlighted-text">{{ loc.name.slice(0, inputLocation.length) }}</span>
            <span>{{ loc.name.slice(inputLocation.length) }}</span>
          </button>
        </li>
      </template>

      <template v-else>
        <li class="no-results-msg">
          <span data-testid="no-results">{{ translate('offDealsNoMatchingResults') }}</span>
        </li>
      </template>
    </ul>
  </div>
  <div class="location--cta">
    <button
      class="btn btn-secondary"
      aria-label="Reset location"
      data-testid="reset-filters-button"
      @click="handleClearLocation"
    >
      <i class="icon-close sm" />
      <span>{{ translate('offDealsClearFilters') }}</span>
    </button>
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('offersDestinations')
export default {
  name: 'MultiOffersLocationModal',
  props: {
    isFullScreen: {
      type: Boolean,
      default: false
    },
    location: {
      type: String,
      required: true
    },
    locations: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      inputLocation: '',
      formattedLocations: []
    }
  },
  mounted() {
    this.formatFilteredLocations()
  },
  computed: {
    filteredLocations() {
      const cleanLocationInput = this.isFullScreen ? this.inputLocation : this.location

      return this.formattedLocations.filter(({ destinationFormatted }) => {
        return !!destinationFormatted.toLowerCase().startsWith(cleanLocationInput.trim().toLowerCase())
      })
    },
    isMobile() {
      return this.isFullScreen && this.isOpen
    },
    isDesktop() {
      return this.location.length > 0 && !this.isFullScreen && this.isOpen
    }
  },
  methods: {
    ...mapMutations(['setFormattedLocation']),
    emitClear() {
      this.$emit('clearFilter')
    },
    handleClick(location) {
      this.$emit('locationSelected', location)
      this.inputLocation = location.name
      this.emitToggle(false)
    },
    emitToggle(isOpen) {
      this.$emit('toggle', isOpen)
    },
    handleClearLocation() {
      this.inputLocation = ''
      this.emitClear()
      this.emitToggle(false)
    },
    formatFilteredLocations() {
      const countriesReceived = this.locations.filter(object => object.type === 'country')
      for (const destination of this.locations) {
        if (destination.type === 'city') {
          let countryCode = destination.code
          const regEx = /[^-]*$/
          countryCode = countryCode.match(regEx)[0]
          const countryBelong = countriesReceived.filter(country => country.code.toLowerCase() === countryCode.toLowerCase())
          const destinationFormatted = destination.name + ', ' + countryBelong[0]?.name
          this.formattedLocations.push({ ...destination, destinationFormatted })
        } else if (destination.type === 'country') {
          const destinationFormatted = destination.name
          this.formattedLocations.push({ ...destination, destinationFormatted })
        }
      }

      this.setFormattedLocation(this.formattedLocations)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  position: absolute;
  padding: 1rem 3rem;
  z-index: 10;
  display: flex;
  height: auto;
  width: 100%;
  margin: 1rem 0 0 0;
  border: 1px solid var(--color-grey);
  border-radius: 10px;
  background-color: var(--color-white);
  max-height: 40rem;
  overflow-y: auto;

}

.modal-container-mobile {
  position: fixed;
  top: 0;
  border-radius: 0;
  height: 100%;
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  overflow-y: auto;
  z-index: 9999;
  .location {
    &--header {
      color: var(--color-grey-dark);
      padding: 2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      border-bottom: 1px solid var(--color-grey-dark);

      h2 {
        margin-bottom: 0;
        font-size: 2rem;
        font-weight: 600;
      }
    }

    &--body {
      margin: 2rem 0 0 0;
      overflow-y: scroll;
      padding: 1rem 2rem;
      width: 100%;

      &::-webkit-scrollbar {
        display: none;
      }
      .filter-input {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        width: 100%;
        input {
          width: 100%;
          border: 1px solid var(--color-grey);
          background-image: none;
          background-color: transparent;
          -webkit-box-shadow: none;
          -moz-box-shadow: none;
          box-shadow: none;
          caret-color: var(--color-red);
          padding: 1rem 2rem;
          border-radius: 25px;
          margin-bottom: 1.5rem;
        }
        input:focus {
          outline: none;
        }
      }
    }
    &--cta {
      margin-top: auto;
      bottom: 0;
      z-index: 10;
      display: flex;
      width: 100%;
      padding: 1.5rem 3rem;
      gap: 1.5rem;
      background-color: var(--color-grey-light);

      @media (min-width: media('tablet-l')) {
        flex-direction: column;
      }

      .btn {
        flex: 1;
        border-radius: 100rem;
        border: none;
        margin: 0;
        padding: 1.5rem 2rem;
      }
      .btn:focus{
        box-shadow: none;
      }
    }
  }
}

.highlighted-text {
  color: var(--color-red);
}

ul.location-results--search {
  list-style: none !important;
  width: 100%;
  li {
    margin-left: 0 !important;
  }

  li button {
    padding: 1rem 0;
  }

  li.hidden {
    display: none;
  }

  & li:not(:last-child) {
    border-bottom: 1px solid var(--color-grey-light);
  }
}
ul.mobile-list {
  overflow-y: auto;
  padding: 0 1.5rem;
}
</style>
